/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDocumentLink = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V13h-2V9h-5V4H6v16h2v2H4zm11 3.414V7h1.586z" />
        <path d="M10 19a4 4 0 0 1 4-4h2v2h-2a2 2 0 1 0 0 4h2v2h-2a4 4 0 0 1-4-4zm13 0a4 4 0 0 1-4 4h-2v-2h2a2 2 0 1 0 0-4h-2v-2h2a4 4 0 0 1 4 4z" />
        <path d="M19 20h-5v-2h5z" />
      </g>
    </g>
  </Icon>
);
export { SvgDocumentLink as DocumentLink };
